(function () {
  'use strict';
  if (window.botNativeCollectionToolbar) { window.botNativeCollectionToolbar.refresh(); return; }
  function restoreSort(toolbar) {
    var section=toolbar.closest('.shopify-section');
    var sort=section&&section.querySelector('[data-bot-toolbar-sort]');
    if(!sort)return;
    sort.removeAttribute('data-bot-toolbar-sort');
    sort.style.removeProperty('--bot-sort-x');sort.style.removeProperty('--bot-sort-y');
    var activator=sort.querySelector('[data-dropdown-activator]');
    if(activator){activator.classList.remove('bot-native-collection-toolbar__sort-control');activator.removeAttribute('aria-label');activator.removeAttribute('title');}
  }
  function adoptSort(toolbar,section) {
    var slot=toolbar.querySelector('.bot-native-collection-toolbar__filter-slot');
    var sort=section.querySelector('.collection-grid__sort');
    var dropdown=sort&&sort.querySelector('dropdown-list');
    var activator=dropdown&&dropdown.querySelector('[data-dropdown-activator]');
    var value=dropdown&&dropdown.querySelector('input[name="sort_by"]');
    if(!slot||!sort||!activator||!value||!dropdown.querySelector('[data-value]')||!customElements.get('dropdown-list')||!customElements.get('facet-filters-form'))return false;
    // Never reparent a connected dropdown: its reconnect callback rebuilds state
    // from a data-list-value attribute that its first initialization removes.
    sort.setAttribute('data-bot-toolbar-sort','');
    activator.classList.add('bot-native-collection-toolbar__sort-control');
    sort.style.setProperty('--bot-sort-x','0px');sort.style.setProperty('--bot-sort-y','0px');
    var target=slot.getBoundingClientRect(),origin=sort.getBoundingClientRect();
    sort.style.setProperty('--bot-sort-x',(target.left-origin.left)+'px');
    sort.style.setProperty('--bot-sort-y',(target.top-origin.top)+'px');
    if(!toolbar.__botSortResizeObserver&&window.ResizeObserver){
      toolbar.__botSortResizeObserver=new ResizeObserver(function(){if(toolbar.isConnected){if(section.querySelector('[data-bot-toolbar-sort]'))adoptSort(toolbar,section);}else toolbar.__botSortResizeObserver.disconnect();});
      toolbar.__botSortResizeObserver.observe(toolbar);toolbar.__botSortResizeObserver.observe(section);
    }
    function label(){if(sort.hasAttribute('data-bot-toolbar-sort')){activator.setAttribute('aria-label','Sort products: '+activator.textContent.trim());activator.setAttribute('title','Sort products');}}
    label();
    if(!sort.__botToolbarSortBound){sort.__botToolbarSortBound=true;sort.addEventListener('change',function(){setTimeout(label,0);});sort.addEventListener('input',function(){setTimeout(label,0);});}
    return true;
  }
  function refresh() {
    document.querySelectorAll('[data-bot-native-collection-toolbar]').forEach(function(toolbar) {
      var section=toolbar.closest('.shopify-section');
      if (!section) return;
      var style=getComputedStyle(toolbar.parentElement);
      toolbar.style.setProperty('--bot-toolbar-inset-left',style.paddingLeft);
      toolbar.style.setProperty('--bot-toolbar-inset-right',style.paddingRight);
      if (toolbar.hasAttribute('data-bot-adopt-collection-title')) {
        var placeholder=toolbar.querySelector('[data-bot-title-placeholder]');
        if (placeholder) {
          var existing=Array.from(document.querySelectorAll('#MainContent h1')).find(function(h){return !h.closest('[data-bot-native-collection-toolbar]');});
          if (!existing) { existing=document.createElement('h1'); existing.textContent=placeholder.textContent; }
          existing.classList.add('bot-native-collection-toolbar__title');
          placeholder.replaceWith(existing);
        }
      }
      var back=toolbar.querySelector('[data-bot-collection-back]');
      if (back && !back.dataset.ready) {
        back.dataset.ready='true';
        try {
          var prior=new URL(document.referrer);
          if(prior.origin===location.origin && prior.href!==location.href && !/\/(checkout|checkouts)(\/|$)/.test(prior.pathname)) {
            back.href=prior.href;
            back.addEventListener('click',function(event){
              if(event.button!==0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey || history.length<2) return;
              event.preventDefault(); history.back();
            });
          }
        } catch (_) { /* Direct visits keep the shopping fallback. */ }
      }
      var proxy=toolbar.querySelector('[data-bot-collection-filter]');
      var modal=section.querySelector('facets-drawer-modal');
      var original=modal && modal.querySelector('button[slot="activator"]');
      var fields=modal && modal.querySelector('smooth-collapse, .filters-wrapper input[type="checkbox"], .filters-wrapper input[type="number"]');
      if(proxy && original && fields && customElements.get('facets-drawer-modal')) {
        restoreSort(toolbar);
        proxy.hidden=false;
        proxy.setAttribute('aria-controls',modal.id);
        original.setAttribute('data-bot-toolbar-original-filter','');
        modal.parentElement.setAttribute('data-bot-toolbar-modal-wrapper','');
        proxy.onclick=function(){original.click();};
        if(!modal.dataset.botToolbarFocus) {
          modal.dataset.botToolbarFocus='true';
          modal.addEventListener('hide-end',function(){if(document.contains(proxy)) proxy.focus({preventScroll:true});});
        }
      } else if(proxy) {
        proxy.hidden=true;
        adoptSort(toolbar,section);
      }
      document.documentElement.classList.add('bot-native-collection-toolbar-ready');
    });
  }
  // Definition, resize and section callbacks can arrive together. Keep the
  // initial/public refresh synchronous; batch subsequent layout work per frame.
  var refreshPending=false;
  function queueRefresh() {
    if(refreshPending)return;
    refreshPending=true;
    window.requestAnimationFrame(function(){refreshPending=false;refresh();});
  }
  window.botNativeCollectionToolbar={refresh:refresh};
  refresh();
  customElements.whenDefined('facets-drawer-modal').then(queueRefresh);
  customElements.whenDefined('dropdown-list').then(queueRefresh);
  customElements.whenDefined('facet-filters-form').then(queueRefresh);
  document.addEventListener('shopify:section:load',queueRefresh);
  window.addEventListener('pageshow',queueRefresh);
  window.addEventListener('resize',queueRefresh);
  var main=document.getElementById('MainContent');
  if (main) new MutationObserver(function(records) {
    var changed=records.some(function(record) { return Array.from(record.addedNodes).some(function(node) {
      return node.nodeType===1 && (node.matches('[data-bot-native-collection-toolbar], facets-drawer-modal, .collection-grid__sort') || node.querySelector('[data-bot-native-collection-toolbar], facets-drawer-modal, .collection-grid__sort'));
    }); });
    if(changed) queueRefresh();
  }).observe(main,{childList:true,subtree:true});
})();
